import { jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement } from "react";
import { cn } from "../v2/utils.js";
function Tabs({ children, scrollable, className, full = true, onTabChange, value: valueProp }) {
    const value = valueProp || 0;
    const tabsChildren = Children.map(children, (child, index)=>{
        if (/*#__PURE__*/ isValidElement(child)) {
            const childValue = void 0 === child.props.value ? index : child.props.value;
            const onClick = (e)=>{
                if ('function' == typeof onTabChange) onTabChange(childValue);
                if ('function' == typeof child.props.onClick) child.props.onClick(e);
            };
            return /*#__PURE__*/ cloneElement(child, {
                selected: childValue === value,
                onClick,
                value: childValue,
                ...child.props
            });
        }
        return child;
    });
    return /*#__PURE__*/ jsx("div", {
        className: cn("tw-inline-flex tw-z-2 tw-max-w-full tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-800 tw-transition-colors tw-duration-150", scrollable ? 'tw-overflow-auto' : 'tw-overflow-hidden', full && 'tw-w-full', className),
        children: tabsChildren
    });
}
const Tabs_Tabs = Tabs;
export default Tabs_Tabs;
export { Tabs };
